import React, { useState } from 'react'
import { BackButton, CancelButton, SubmitButton } from '../../../../Components/Utils/Buttons';
import { NuInput, NuMobileNumber, NuTextArea } from '../../../../Components/Utils/Input';
import Attachement from '../../../../Components/Utils/CustomAttrachmentupload';
import { useFormik } from 'formik';
import useAddFormData from '../../../../Components/Hooks/useAddFormData';
import * as yup from "yup";
import FormikSelectTwo, { FormikSelectWithAdd } from '../../../../Components/Utils/Select';
import { useToast } from '../../../../Components/Others/ToastServices';
import DropDownAddMetaData from '../../../../Components/Utils/selectAddMetaData';
import CustomImgUpload from '../../../../Components/Utils/CustomImgUpload';
import useFetchMataData from '../../../../Components/Hooks/useFetchMataData';
import { CountryMIN } from "../../../../assets/CountryMini";
import UseDropDown from '../../../../Components/Hooks/useDropDown';
import { MultiSelectSet } from '../../../../Components/Utils/MultiSelect';
import useFetchMetaStar from '../../../../Components/Hooks/useFetchMetaStar';
import Breadcrumb from '../../../../Components/Utils/Breadcrumb';
const filetype = [
  "docx",
  "doc",
  "xlsx",
  "xls",
  "pdf",
  "PDF",
  "txt",
  "pptx",
  "mp4",
  "mov",
  "wmv",
  "avi",
  "flv",
  "mkv",
];

function CreateClient() {
  const { value: industry, getData: refindustry } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "Industry_Client"
  );
  const { value: designation, getData: refdesignation } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "Designation_Client"
  );
  const { value: Rating } = useFetchMetaStar(
    `/dropdown/dropdown-details/`,
    "Rating_Client"
  );
  const { data: user } = UseDropDown(`/user/drop-down`);
  const toast = useToast();
  const [image, setImage] = useState([]);
  // const [image, setImage] = useState({ preview: "", raw: "" });


  const { Oncancel, addFormData, contextHolder, isLoading } = useAddFormData();
  const [items, setItems] = useState([]);
      const [selectedUsers, setSelectedUsers] = useState([]);
  

  const [createNew, setCreateNew] = useState({
    
  
    category:"",
    companyName: "",
    industry: "",
    address1:"",
    address2:"",
    city:"",
    streetName:"",
    district:"",
    state:"",
    postalCode:"",
    country:"",
    billingAddress1:"",
    billingAddress2:"",
    billing_city:"",
    billing_state:"",
    billing_postal_code:"",
    billing_country:"",
    shippingAddress1:"",
    shippingAddress2:"",
    shipping_city:"",
    shipping_state:"",
    shipping_postal_code:"",
    shipping_country:"",
    designation:"",
    email:"",
    countryCode:"",
    phone:"",
    website:"",
    crNum:"",
    vatNum:"",
    salesPerson:null,
    ratings:"",
    pcName:"",
    pcDesignation:"",
    pcCountryCode:"",
    pcMobile:"",
    pcEmail:"",
    scName:"",
    scDesignation:"",
    scCountryCode:"",
    scMobile:"",
    scEmail:"",
    // image:[],
    // deadLine: currentDate || "",
  
  });
  const [error, setError] = useState("");

  const [selectedFile, setSelectedFile] = useState([]);
  const [fileNames, setFileNames] = useState([]);

  function handleImageChange(e) {
    const maxFileSize = 200000000; // 200 MB
    const files = Array.from(e.target.files);
    let fileArr = [];
    files.map((item) => {
      if (item.size < maxFileSize) {
        fileArr.push(item);
      } else {
        toast.open({
          type: "warning",
          message: `File Size to big`,
          description: `${item.name} is Removed and not Uploaded`,
          // placement: "bottomRight",
        });
      }
    });
    let tempArr = [];
    setSelectedFile(fileArr);
    files.map((item) => {
      if (item.size < maxFileSize) {
        let fileName = item?.name;
        console.log("fname", fileName);
        // let fileExtention = fileName.split(".").reverse()[0];
        // if (filetype?.includes(fileExtention)) {
        tempArr.push(fileName);
        // } else {
        //   let x = URL.createObjectURL(item);
        //   tempArr.push(x);
        // }
      }
    });
    console.log(tempArr, "temp");
    setImage(tempArr);
  }

  const removeImages = (value) => {
    console.log("value", value);
    let List = selectedFile.filter((item) => item?.name !== value);
    console.log("LIst", List);
    setSelectedFile([...List]);
    let tempArr = [];
    List.map((item) => {
      let fileName = item?.name;
      // console.log('fname',fileName);
      // let fileExtention =  fileName.split(".").reverse()[0]
      // if(filetype?.includes(fileExtention)){
      tempArr.push(fileName);
      // }else{
      //   let x = URL.createObjectURL(item)
      //   tempArr.push(x)
      // }
    });
    setImage(tempArr);
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      companyName: yup.string().required("Company Name is required!"),
      // salesPerson: yup.string().required("Sales person is required!"),

      phone: yup
         .string()
         .matches(/^\d+$/, "Phone number must contain only digits")
         .min(8, "Phone number must be at least 8 digits")
         .max(11, "Phone number must be at most 11 digits")
         .required("Phone number is required"),
      pcDesignation: yup
        .string()
        .required("Primary Contact Designation is required!"),
        pcName: yup.string().required("Primary Contact Person Name is required!"),
        pcMobile: yup
         .string()
         .matches(/^\d+$/, "Phone number must contain only digits")
         .min(8, "Phone number must be at least 8 digits")
         .max(11, "Phone number must be at most 11 digits")
         .required("Phone number is required"),

         pcEmail: yup
         .string()
         .email("Invalid email format")
         .required("Email is required!"),

         email: yup
         .string()
         .email("Invalid email format")
         .required("Email is required!"),
    }),
    onSubmit: async (value, { resetForm }) => {
      // setLoading(true);
      // if (items.length === 0) {
      //   // setError("Product table is empty");
      //   // setLoading(false)

      //   return;
      // }
      let formData = new FormData();
      const valueWithItems = {
        ...value,
        productList: items,
      };
      formData.append("json_data", JSON.stringify(valueWithItems));
      // formData.append('attachments', image.raw);
      formData.append("clientLogo", image.raw);
 
      addFormData(`/clients/new-client`, formData, resetForm);
      // setLoading(false)
    },
  });

  const handleChangeImg = (e) => {
    if (e.target.files.length) {
        setImage({
            preview: URL.createObjectURL(e.target.files[0]),
            raw: e.target.files[0],
        });
    }
};
const handleImageRemove = () => {
    setImage({
        preview: "",
        raw: "",
    });
}
const [useShipAddress,setShipAddress] = useState(false);
function handleShipAddress(e){
  setShipAddress(e.target.checked);
  if(e.target.checked){
    formik.values.shippingAddress1 = formik.values.billingAddress1
    formik.values.shippingAddress2 = formik.values.billingAddress2
    formik.values.shipping_country = formik.values.billing_country
    formik.values.shipping_city = formik.values.billing_city
    formik.values.shipping_state = formik.values.billing_state
    formik.values.shipping_postal_code = formik.values.billing_postal_code
  }else{
    formik.values.shippingAddress1 = ""
    formik.values.shippingAddress2 = ""
    formik.values.shipping_country = ""
    formik.values.shipping_city = ""
    formik.values.shipping_state =  ""
    formik.values.shipping_postal_code = ""
  }
}

const [address,setAddress] = useState(false);
function handleAddress(e){
  setAddress(e.target.checked);
  if(e.target.checked){
    formik.values.billingAddress1 = formik.values.address1
    formik.values.billingAddress2 = formik.values.address2
    formik.values.billing_country = formik.values.country
    formik.values.billing_city = formik.values.city
    formik.values.billing_state = formik.values.state
    formik.values.billing_postal_code = formik.values.postalCode
  }else{
    formik.values.billingAddress1 = ""
    formik.values.billingAddress2 = ""
    formik.values.billing_country = ""
    formik.values.billing_city = ""
    formik.values.billing_state =  ""
    formik.values.billing_postal_code = ""
  }
}

const [billAddress,setBillAddress] = useState(false);
function handleBillAddress(e){
  setBillAddress(e.target.checked);
  if(e.target.checked){
    formik.values.shippingAddress1 = formik.values.address1
    formik.values.shippingAddress2 = formik.values.address2
    formik.values.shipping_country = formik.values.country
    formik.values.shipping_city = formik.values.city
    formik.values.shipping_state = formik.values.state
    formik.values.shipping_postal_code = formik.values.postalCode
  }else{
    formik.values.shippingAddress1 = ""
    formik.values.shippingAddress2 = ""
    formik.values.shipping_country = ""
    formik.values.shipping_city = ""
    formik.values.shipping_state =  ""
    formik.values.shipping_postal_code = ""
  }
}
const handleUserSelect = (selectedOptions) => {
  setSelectedUsers(selectedOptions);
}
  return (
    <div className='w-full h-full py-2 px-4 '>
    <div className="flex justify-between mb-4">
      <Breadcrumb
                        items={[
                          // { name: "Client-Management" },
                          {
                            name: "Client",
                            link:"/client-management/clients"
                           
                          },
              
                          { name: "Create" },
                        ]}
                      />
        <BackButton />
      </div>

      <div className="w-full mx-auto h-[calc(100vh-151px)]  overflow-y-auto ">
      <form onSubmit={formik.handleSubmit}>
      <div className="w-full mx-auto p-4 bg-white rounded-md ">

            <div className="w-full h-full flex justify-start content-start flex-wrap   mb-4">
              
            <div className="w-full">
              <p className="pb-2 pt-4 px-4 text-sm font-medium text-[#111537] underline decoration-textColor-main decoration-2 underline-offset-4">
                Client:
              </p>
                       </div>
                                    <CustomImgUpload
                                        borderStyle="dashed"
                                        isRemove={true}
                                        width='w-full md:w-1/2'
                                        removeFunction={handleImageRemove}
                                        handleChange={handleChangeImg}
                                        preview={image.preview || createNew.image || ""}
                                    />
              <NuInput
                label="Company Name"
                type="text"
                formik={formik}
                placeholder="Company Name"
                name="companyName"
                width="w-full md:w-1/2 lg:w-2/3"
                isRequired={true}

              />
              
               <DropDownAddMetaData
                type="text"
                label="Industry"
                placeholder="Industry"
                Options={industry}
                formik={formik}
                name="industry"
                width="w-full md:w-1/2 lg:w-1/3"
                displayProperty={"Industry"}
              propertyName={"Industry_Client"}
              getFunc={refindustry}

                
              />
                 
               <NuInput
              type="email"
              label="Email"
              placeholder="Email"
              formik={formik}
              name="email"
              width="w-full md:w-1/2 lg:w-1/3"
            />
             <NuMobileNumber
              nunCode="countryCode"
              label="Phone"
              placeholder="Phone"
              formik={formik}
              name="phone"
              isRequired={true}

              width="w-full md:w-1/2 lg:w-1/3"
            />
             <NuInput
                label="Website"
                type="text"
                formik={formik}
                placeholder="Website"
                name="website"
                width="w-full md:w-1/2 lg:w-1/3"
              />
              <NuInput
                type="text"
                label="CR Number"
                placeholder="CR Number"
                formik={formik}
                // Options={Invoice} 
                name="crNum"
                width="w-full md:w-1/2 lg:w-1/3"
                // disabled={true} 
              />
  <NuInput
  type="text"
  label="VAT Number"
  placeholder="VAT Number"
  formik={formik}
  // Options={Invoice} 
  name="vatNum"
  width="w-full md:w-1/2 lg:w-1/3"
  // disabled={true} 
/>
<FormikSelectTwo
                Options={user}
               label="Sales Preson"
                placeholder="Choose"
                value={selectedUsers}
                // onChange={handleUserSelect}
                formik={formik}
                name="salesPerson"
                width="w-full md:w-1/2 lg:w-1/3"
              />
              <DropDownAddMetaData
  type="number"
  label="Rating"
  placeholder="Rating"
  Options={Rating}
  formik={formik}
  name="ratings"
  width="w-full md:w-1/2 lg:w-1/3"
  displayProperty={"Rating"}
  propertyName={"Rating_Client"}
  // getFunc={refRating}
  // disabled={true} 
/>

            
             

              {/* <div className="w-full">
                <p className="pb-2 pt-4 px-4 text-sm font-medium text-[#111537] underline decoration-[#3369ff] decoration-2 underline-offset-4">
                   Attachement :
                </p>
              </div> */}
              {/* <Attachement
                handleChange={handleImageChange}
                preview={[] || ""}
                width="w-full"
                label="Attach"
                multiple={true}
                removeImages={removeImages}
              /> */}
              
            </div>
           </div>

           <div className='sm:flex gap-2'>
            <div className="sm:w-[50%] mx-auto p-4 bg-white rounded-md mt-4 ">
            <div className=" w-full h-full flex justify-start content-start flex-wrap mb-4">
              <div className="w-full">
                <p className="pb-2 pt-4 px-4 text-sm font-medium text-[#111537] underline decoration-textColor-main decoration-2 underline-offset-4">
                 Primary Contact :
                </p>
              </div>
              <NuInput
              type="text"
              label="Contact Person Name"
              placeholder="Contact Person Name"
              formik={formik}
              name="pcName"
              isRequired={true}
              width="w-full md:w-1/2 lg:w-1/2"
            />

              <DropDownAddMetaData
                type="text"
                label="Designation"
                placeholder="Designation"
                Options={designation}
                formik={formik}
                name="pcDesignation"
                width="w-full md:w-1/2 lg:w-1/2 md:-mt-1"
                isRequired={true}
                displayProperty={"Designation"}
              propertyName={"Designation_Client"}
              getFunc={refdesignation}

                
              />

              <NuMobileNumber
              nunCode="pcCountryCode"
              label="Phone"
              placeholder="Phone"
              formik={formik}
              name="pcMobile"
              isRequired={true}

              width="w-full md:w-1/2 lg:w-1/2"
            />

              <NuInput
              type="email"
              label="Email"
              placeholder="Email"
              formik={formik}
              name="pcEmail"
              isRequired={true}
              width="w-full md:w-1/2 lg:w-1/2"
            />

            </div>
            {/* <div className=" px-4 pb-2 flex gap-1">
              <input
                type="checkbox"
                checked={useAddress}
                onChange={handleAddress}
              />
              <label className=" text-xs">
                Use Billing Address as Shipping Address
              </label>
            </div> */}
          </div>

          <div className="sm:w-[50%] mx-auto p-4 bg-white rounded-md mt-4 ">
            <div className=" w-full h-full flex justify-start content-start flex-wrap mb-4">
              <div className="w-full">
                <p className="pb-2 pt-4 px-4 text-sm font-medium text-[#111537] underline decoration-textColor-main decoration-2 underline-offset-4">
                  Secondary Contact :
                </p>
              </div>

              <NuInput
              type="text"
              label="Contact Person Name"
              placeholder="Contact Person Name"
              formik={formik}
              name="scName"
              width="w-full md:w-1/2 lg:w-1/2"
            />

                <DropDownAddMetaData
                type="text"
                label="Designation"
                placeholder="Designation"
                Options={designation}
                formik={formik}
                name="scDesignation"
                width="w-full md:w-1/2 lg:w-1/2 md:-mt-1"
                displayProperty={"Designation"}
              propertyName={"Designation_Client"}
              getFunc={refdesignation}

                
              />

<NuMobileNumber
              nunCode="scCountryCode"
              label="Phone"
              placeholder="Phone"
              formik={formik}
              name="scMobile"

              width="w-full md:w-1/2 lg:w-1/2"
            />

<NuInput
              type="email"
              label="Email"
              placeholder="Email"
              formik={formik}
              name="scEmail"
              width="w-full md:w-1/2 lg:w-1/2"
            />
            
            
          
          

            </div>
           

          </div>
         </div>

            <div className="w-full mx-auto  bg-white rounded-md  mt-4 p-4 ">
            <div className=" w-full h-full flex justify-start content-start flex-wrap   mb-4">
            <div className="w-full">
                <p className="pb-2 pt-4 px-4 text-sm font-medium text-[#111537] underline decoration-textColor-main decoration-2 underline-offset-4">
                Address :
                </p>
              </div>

              <NuInput
                type="text"
                label=" Address Line 1"
                placeholder=" Address Line 1"
                formik={formik}
                name="address1"
                width="w-full md:w-1/2 lg:w-1/3"
              />

              <NuInput
                type="text"
                label=" Address Line 2"
                placeholder="Street Address Line 2"
                formik={formik}
                name="address2"
                width="w-full md:w-1/2 lg:w-1/3"
              />

              <NuInput
                type="text"
                label="City"
                placeholder="City"
                formik={formik}
                name="city"
                width="w-full md:w-1/2 lg:w-1/3"
              />
              <NuInput
                type="text"
                label="Street Name"
                placeholder="Street Name"
                formik={formik}
                name="streetName"
                width="w-full md:w-1/2 lg:w-1/3"
              />
                <NuInput
                type="text"
                label="District"
                placeholder="District"
                formik={formik}
                name="district"
                width="w-full md:w-1/2 lg:w-1/3"
              />

              <NuInput
                type="text"
                label="State / Province"
                placeholder="State / Province"
                formik={formik}
                name="state"
                width="w-full md:w-1/2 lg:w-1/3"
              />

              <NuInput
                type="number"
                label="Postal / Zip Code"
                placeholder="Postal / Zip Code"
                formik={formik}
                name="postalCode"
                width="w-full md:w-1/2 lg:w-1/3"
              />

              <FormikSelectTwo
                type="text"
                label="Country"
                placeholder="Country"
                Options={CountryMIN}
                formik={formik}
                name="country"
                width="w-full md:w-1/2 lg:w-1/3"
                FixPosition={false}
                PortalTarget={false}
              />

              
            </div>
           
          </div>
          <div className="w-full mx-auto  bg-white rounded-md  mt-4 p-4 ">
            <div className=" w-full h-full flex justify-start content-start flex-wrap   mb-4">
            <div className="w-full sm:flex">
                <p className="pb-2 pt-4 px-4 text-sm font-medium text-[#111537] underline decoration-textColor-main decoration-2 underline-offset-4">
                 Billing Address :
                </p>

                <div className=" pb-2 pt-4 px-4 flex gap-1">
                  <input type="checkbox" checked={address} onChange={handleAddress} />
                  <label className=" text-xs py-0.5">Same as Address</label>
                </div>
              </div>

              <NuInput
                type="text"
                label="Street Address Line 1"
                placeholder="Street Address Line 1"
                formik={formik}
                name="billingAddress1"
                width="w-full md:w-1/2 lg:w-1/3"
              />

              <NuInput
                type="text"
                label="Street Address Line 2"
                placeholder="Street Address Line 2"
                formik={formik}
                name="billingAddress2"
                width="w-full md:w-1/2 lg:w-1/3"
              />

              <NuInput
                type="text"
                label="City"
                placeholder="City"
                formik={formik}
                name="billing_city"
                width="w-full md:w-1/2 lg:w-1/3"
              />

              <NuInput
                type="text"
                label="State / Province"
                placeholder="State / Province"
                formik={formik}
                name="billing_state"
                width="w-full md:w-1/2 lg:w-1/3"
              />

              <NuInput
                type="number"
                label="Postal / Zip Code"
                placeholder="Postal / Zip Code"
                formik={formik}
                name="billing_postal_code"
                width="w-full md:w-1/2 lg:w-1/3"
              />

              <FormikSelectTwo
                type="text"
                label="Country"
                placeholder="Country"
                Options={CountryMIN}
                formik={formik}
                name="billing_country"
                width="w-full md:w-1/2 lg:w-1/3"
                FixPosition={false}
                PortalTarget={false}
              />

              
            </div>
            
          </div>
          <div className="w-full mx-auto  bg-white rounded-md  mt-4 p-4 ">
            <div className=" w-full h-full flex justify-start content-start flex-wrap">
            <div className="w-full sm:flex">
                <p className="pb-2 pt-4 px-4 text-sm font-medium text-[#111537] underline decoration-textColor-main decoration-2 underline-offset-4">
                  Shipping Address :
                </p>
                <div className=" pb-2 pt-4 px-4 flex gap-1">
                  <input type="checkbox" checked={billAddress} onChange={handleBillAddress} />
                  <label className=" text-xs py-0.5">Same as Address</label>
                </div>
                <div className=" pb-2 pt-4 px-4 flex gap-1">
                  <input type="checkbox" checked={useShipAddress} onChange={handleShipAddress} />
                  <label className=" text-xs py-0.5">Same as Billing Address</label>
                </div>
              </div>

              <NuInput
                type="text"
                label="Street Address Line 1"
                placeholder="Street Address Line 1"
                formik={formik}
                name="shippingAddress1"
                width="w-full md:w-1/2 lg:w-1/3"
              />

              <NuInput
                type="text"
                label="Street Address Line 2"
                placeholder="Street Address Line 2"
                formik={formik}
                name="shippingAddress2"
                width="w-full md:w-1/2 lg:w-1/3"
              />

              <NuInput
                type="text"
                label="City"
                placeholder="City"
                formik={formik}
                name="shipping_city"
                width="w-full md:w-1/2 lg:w-1/3"
              />

              <NuInput
                type="text"
                label="State / Province"
                placeholder="State / Province"
                formik={formik}
                name="shipping_state"
                width="w-full md:w-1/2 lg:w-1/3"
              />

              <NuInput
                type="number"
                label="Postal / Zip Code"
                placeholder="Postal / Zip Code"
                formik={formik}
                name="shipping_postal_code"
                width="w-full md:w-1/2 lg:w-1/3"
              />

              <FormikSelectTwo
                type="text"
                label="Country"
                placeholder="Country"
                Options={CountryMIN}
                formik={formik}
                name="shipping_country"
                width="w-full md:w-1/2 lg:w-1/3"
                FixPosition={false}
                PortalTarget={false}
              />

              {/* <NuTextArea
                label="Comments"
                placeholder="Comments"
                formik={formik}
                name="comments"
                width="w-full md:w-1/2 "
                new_width="w-full lg:w-2/3"
              /> */}

              {/* <div className="w-full  mx-auto my-4 mt-8 ">
                <div className="flex justify-end gap-4">
                  <CancelButton
                    handleClick={() => {
                      Oncancel(-1);
                    }}
                  />
                  <SubmitButton isLoading={isLoading} />
                </div>
              </div> */}
              <div className="w-full mx-auto my-4 mt-8 pb-2">
                <div className="flex justify-end item-end float-right mx-auto md:mx-0 gap-2 pb-4 mt-6 md:mr-4">
                  <CancelButton
                    handleClick={() => {
                      Oncancel(-1);
                    }}
                  />
                  <SubmitButton isLoading={isLoading} />
                </div>
              </div>
            </div>
            
          </div>

          
          
            
          </form>
            
          </div>
          


      </div>
  )
}

export default CreateClient;